<div class="promo-block">
  <!-- Title -->
  @if (isBMSTVmode) {
    <h2 class="promo-block__title">
      Beats by
      <span class="promo-block__title--link" (click)="toBeatmakerPage(beatmakerId)">
        {{ beatmakerName }}
      </span>
    </h2>
  } @else {
    <h2 class="promo-block__title theme-cartPage__title">
      {{ lg.cartPage.orderText }}
    </h2>
  }

  <div class="promo-block__input-box">
    <input
      type="text"
      class="promo-block__input theme-cartPage__input theme-cartPage__input-placeholder"
      placeholder="{{ lg.cartPage.coupon }}"
      (input)="changePromoCodeValue($event)"
    />
  </div>
  <div class="promo-block__btn-container">
    <bmcore-button
      [themeBtnClass]="disabled ? 'theme-btn__cartPage-disabledBtnCoupon' : 'theme-btn__cartPage-btnCoupon'"
      [themeIconClass]="disabled ? 'theme-icon__cartPage-disabledBtnCouponIcon' : 'theme-icon__cartPage-btnCouponIcon'"
      title="{{ lg.button.apply }}"
      icon="btv-icon-btn-label"
      (clickHandler)="checkCoupon()"
      [disabled]="disabled"
    >
    </bmcore-button>
  </div>

  <!-- Check coupon -->
  @if (isCouponChecked && !hasDiscount) {
    <p class="promo-block__message promo-block__message--error">
      {{ lg.cartPage.couponErrorInvalid }}
    </p>
  }
  @if (isCouponChecked && hasDiscount) {
    <p class="promo-block__message promo-block__message--success">
      {{ lg.cartPage.couponSuccessMessage }}
    </p>
  }
</div>
